import { render, staticRenderFns } from "./3BreedingMaterial.vue?vue&type=template&id=1d4249c8&scoped=true&"
import script from "./3BreedingMaterial.vue?vue&type=script&lang=js&"
export * from "./3BreedingMaterial.vue?vue&type=script&lang=js&"
import style0 from "./3BreedingMaterial.vue?vue&type=style&index=0&id=1d4249c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4249c8",
  null
  
)

export default component.exports